var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.5C4.95312 0.5 0.5 4.99219 0.5 10.5C0.5 16.0469 4.95312 20.5 10.5 20.5C16.0078 20.5 20.5 16.0469 20.5 10.5C20.5 4.99219 16.0078 0.5 10.5 0.5ZM14.6406 13.9766C14.9531 14.3672 14.9141 14.9531 14.5234 15.3047C14.3672 15.4609 14.1328 15.5 13.9375 15.5C13.6641 15.5 13.3906 15.4219 13.1953 15.1875L10.5 11.9844L7.76562 15.1875C7.57031 15.4219 7.29688 15.5 7.02344 15.5C6.82812 15.5 6.63281 15.4609 6.4375 15.3047C6.04688 14.9531 6.00781 14.3672 6.32031 13.9766L9.25 10.5L6.32031 7.0625C6.00781 6.67188 6.04688 6.08594 6.4375 5.73438C6.82812 5.42188 7.41406 5.46094 7.76562 5.85156L10.5 9.05469L13.1953 5.85156C13.5469 5.46094 14.1328 5.42188 14.5234 5.73438C14.9141 6.08594 14.9531 6.67188 14.6406 7.0625L11.7109 10.5L14.6406 13.9766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCancelled);
export default __webpack_public_path__ + "static/media/order-cancelled.548f54a598b8d7684c7d02ecbb68d007.svg";
export { ForwardRef as ReactComponent };